import { HelpRule, LiveViewRow } from './interfaces';
import { timeSpentAt } from './timeSpent';

// May Need Help, worked out in the browser from the row and the rules the
// server sends with each snapshot (LiveView::MayNeedHelp.rules), so staff can
// try other thresholds without a deploy.

export interface HelpFlags {
  lowScore: boolean,
  tooLong: boolean,
}

const NOT_FLAGGED: HelpFlags = { lowScore: false, tooLong: false };

type QuestionTimeFields = Pick<LiveViewRow, 'questionTimeSeconds'|'questionTimeAsOf'|'idle'>;

// The tool's active time on the current question at `now`: its last report
// plus the time since, unless the tool has stopped counting for inactivity.
// Null when the student is not on a question.
export const questionTimeAt = (row: QuestionTimeFields, now: Date): number|null => {
  if (row.questionTimeSeconds === null || row.questionTimeSeconds === undefined) { return null; }

  const sinceReport = !row.idle && row.questionTimeAsOf ? Math.max((now.getTime() - new Date(row.questionTimeAsOf).getTime()) / 1000, 0) : 0;
  return Math.floor(row.questionTimeSeconds + sinceReport);
};

// Low Score: at least minFailed incorrect, and at least failedRatio of the
// completed questions
const lowScore = (row: LiveViewRow, rule: HelpRule): boolean => {
  const completed = row.prompts.length;
  const failed = row.prompts.filter(prompt => !prompt.optimal).length;
  if (!completed || failed < rule.minFailed) { return false; }

  return failed / completed >= rule.failedRatio;
};

// Long Time on Question: questionSeconds on the current question, once the
// student has spent minTimeSpent on the activity
const tooLong = (row: LiveViewRow, rule: HelpRule, now: Date): boolean => {
  const questionTime = questionTimeAt(row, now);
  if (questionTime === null || row.timeSpentSeconds === null || row.timeSpentSeconds === undefined) { return false; }
  if (timeSpentAt(row, now) < rule.minTimeSpent) { return false; }

  return questionTime >= rule.questionSeconds;
};

export const helpFlags = (row: LiveViewRow, rule: HelpRule|undefined, now: Date): HelpFlags => {
  if (!rule || rule.unflaggedReason || row.onlineOnly || row.redacted) { return NOT_FLAGGED; }

  return { lowScore: lowScore(row, rule), tooLong: tooLong(row, rule, now) };
};
